import React, {Component} from 'react';
import {
} from 'reactstrap';
import { Button, Input, Select, Dropdown, Container, Grid } from 'semantic-ui-react';


class SearchResultList extends Component {
    render() {
        const data = this.props.data;
        if (!data) {
            return (null);
        }
        const resultNodes = data.map((row) => {
            if(row.category.indexOf('組込み') == -1){
                return <SearchResult row={row}/>;
            }
            else{
                return null;
            }
        }
        );

        return (
            <Grid id="SearchResult">
                <Grid.Row>
                    {resultNodes}
                </Grid.Row>
            </Grid>
        );
    }
}

class SearchResult extends Component {
    render() {
        return (
            <Grid.Column computer={4} mobile={8}>
                <a target="_blank" href={this.props.row.embed_url}>
                    <img width="100" src={this.props.row.thumbnail_url} alt=""/>
                </a>
                <h3>
                    <a target="_blank" href={this.props.row.embed_url}>
                        {this.props.row.title}
                    </a>
                </h3>
                <small className="text-muted">
                    <img style={{width:12,height:12,marginRight:2}} src={this.props.row.shared+".png"} alt={this.props.row.shared}/>
                    {/*｜*/}
                    再生回数: {this.props.row.count}回
                </small>
                <br/>
                <small className="text-muted">
                    {this.props.row.category}
                </small>
            </Grid.Column>
        );
    }
}

export default SearchResultList;


// WEBPACK FOOTER //
// ./src/component/SearchResultList.js